import script from "./Picture.vue?vue&type=script&setup=true&lang=ts"
export * from "./Picture.vue?vue&type=script&setup=true&lang=ts"

import "./Picture.vue?vue&type=style&index=0&id=2ebed4ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ebed4ee"]])

export default __exports__